
export const language = {
    general:{
        error: 'Algo deu errado. Tente novamente.',
        exit: 'sair',
        welcome: 'Bem vindo',
        or:"ou",
        and:"e",
        from:"de",
        partner:"parceiro",
        fromAssitive: "da Assistive.",
        signin:"Entrar",
        terms: "termos de uso",
        policy:"política de privacidade",
        resend: "Reenviar",
        needHelp:"Precisa de ajuda?",
        helpCenterText: "Visite nossa central para acessar informações adicionais sobre a instalação e melhores práticas de uso.",
        helpCenter:"Central de ajuda",
        loading: "carregando",
        close: "Fechar",
        typeToSearch: "Digite para pesquisar…",
        noResults: "Nenhum resultado",
        domain: 'Domínio',
        action: 'Ações',
        active: 'Ativar',
        inactive:'Desativar',
        delete:'excluir',
        pagingMessage_one:'Mostrando {{param1}} a {{param2}} de {{param3}} linha',
        pagingMessage_other:'Mostrando {{param1}} a {{param2}} de {{param3}} linhas',
        badges: {
            active: 'Ativo',
            expired: 'Expirado',
            grace: 'Carência',
            trial: 'Trial',
            incomplete: 'Pagamento pendente',
            provisioning: 'Provisionando',
            suspended: 'Suspenso',
            cancelled: 'Cancelado',
            disabled: 'Desativado'
        },
        clipboard: {
            copied: 'Copiado para a área de transferência',
            error: 'Falha ao copiar'
        }

    },
    footer:{
        rights:"Todos os direitos reservados.",
        terms:"Termos de uso",
        privacy:"Política de privacidade",
        partner:"Seja um parceiro",
        help:"Central de ajuda",
        version:"Versão"
    },
    menu:{
        home: 'Inicio',
        report:'Relatórios',
        perfil:'Perfil',
        hidMenu:'Esconder menu',
        showMenu:'Exibir menu',
        addSite: 'Adicionar novo site',
        peopleUnique: 'Porque as pessoas são únicas...',
        activeSite:'site ativo',
        activeSites:'sites ativos'

    },
    navbar: {
        homePage: 'Página inicial',
        expandMenu: 'Expandir menu lateral',
        noDomain: 'Nenhum domínio cadastrado',
        siteSearchPlaceholder: 'Digite pra buscar…',
        siteSearchNoResults: 'Nenhum domínio encontrado',
        userDropdown: {
            trialPlan: 'Teste Grátis',
            defaultPlan: 'Plano Atual',
            profile: 'Perfil',
            account: 'Conta',
            logout: 'Sair'
        }
    },
    verticalMenu:{
        sites: "Sites",
        dashboard: "Dashboard",
        installation: "Instalação",
        aiContent: "Conteúdo IA",
        alternativetexts: "Textos alternativos",
        socialimages: "Imagens sociais",
        aicontentreview: "Revisão de IA"
    },
    form:{
        user: 'Usuário',
        password:'Senha',
        login:'Entrar'
    },
    home :{
        greetings:"Bem vindo ao sistema"
    },
    views:{
        aiContent: {
            alternativeTexts: {
                title: "Textos alternativos",
                subtitle: "Gerencie e melhore os textos alternativos das imagens do seu site.",
                globalAlert: {
                    title: "Nenhuma imagem encontrada ainda:",
                    description: "Estamos coletando as imagens do seu site."
                },
                generateAllButton: "Gerar ALT com IA",
                generateAllModal: {
                    title: "Gerar ALT em massa",
                    body: "Este comando dispara a IA em todas as imagens sem descrição do domínio atual. Imagens já aprovadas ou ignoradas são puladas.",
                    comingSoon: "Em breve na próxima fase (5c)."
                },
                tabs: {
                    all: "Todas",
                    catalogued: "Sem ALT",
                    aiGenerated: "Sugeridas pela IA",
                    needsReview: "Precisam revisão",
                    approved: "Aprovadas",
                    ignored: "Ignoradas"
                },
                sortBy: {
                    label: "Ordenar por",
                    placeholder: "Ordenar por score…",
                    recent: "Atualizados (recentes)",
                    oldest: "Atualizados (antigos)",
                    alphaAsc: "A → Z",
                    alphaDesc: "Z → A",
                    scoreAsc: "Score (menor → maior)",
                    scoreDesc: "Score (maior → menor)"
                },
                bulk: {
                    selected: "{{count}} selecionadas",
                    approve: "Aprovar",
                    ignore: "Ignorar",
                    clear: "Limpar seleção",
                    selectAll: "Selecionar todas",
                    selectRow: "Selecionar linha",
                    success: "{{count}} itens atualizados",
                    partial: "{{ok}} de {{total}} atualizados (o restante falhou)"
                },
                scoreCard: {
                    title: "Relatório de Acessibilidade",
                    computing: "Avaliando este alt com IA…",
                    recalculating: "Atualizando score…",
                    notScoredYet: "Este alt ainda não foi avaliado. O score é calculado automaticamente após editar, aprovar ou regenerar.",
                    confidence: "Confiança da IA",
                    readingTime: "Tempo de leitura estimado: {{seconds}}s",
                    levels: {
                        excellent: "Ótimo",
                        good: "Bom",
                        fair: "Regular",
                        poor: "Fraco"
                    },
                    confidenceLevels: {
                        high: "Alta",
                        medium: "Média",
                        low: "Baixa"
                    },
                    dimensions: {
                        subject: "Assunto (Assunto principal)",
                        action: "Ação (Ação relevante)",
                        context: "Contexto",
                        objects: "Objetos (Objetos relevantes)",
                        clarity: "Clareza (Clareza e concisão)",
                        size: "Tamanho (Comprimento adequado)",
                        wcag: "Conformidade WCAG",
                        redundancy: "Sem redundância"
                    }
                },
                historyAccordion: {
                    title: "Histórico de versões",
                    empty: "Nenhuma alteração anterior.",
                    restore: "Restaurar",
                    previousScore: "Score anterior: {{score}}"
                },
                filters: {
                    pageUrl: "URL da página",
                    pageUrlPlaceholder: "Buscar por URL, arquivo ou alt…",
                    status: "Status",
                    source: "Origem",
                    fileType: "Tipo de arquivo",
                    all: "Todos os formatos",
                    // Redesign — 5 filtros
                    sitePlaceholder: "Todos os sites",
                    pagePlaceholder: "Todas as páginas",
                    pageSearchPlaceholder: "Digite pra buscar…",
                    allPages: "Todas as páginas",
                    noPages: "Nenhuma página encontrada",
                    textSourceLabel: "Origem do texto",
                    textSourceAll: "Todas as origens",
                    reviewLabel: "Revisão",
                    reviewAll: "Todas as revisões",
                    reviewReviewed: "Revisada",
                    reviewNotReviewed: "Não revisada",
                    reviewIgnored: "Ignorada",
                    activityLabel: "Status da imagem",
                    activityAll: "Todos os status",
                    activityActive: "Ativa no site",
                    activityRemoved: "Removida do site",
                    fileTypeLabel: "Tipo de arquivo",
                    fileTypeAll: "Todos os formatos",
                    more: "Mais filtros",
                    clear: "Limpar filtros",
                    contentChanged: "Imagem alterada",
                    scanTitle: "Verificar imagens agora",
                    scanSubtitle: "Detecta se o conteúdo mudou",
                    scanRunning: "Verificando...",
                    scanTooltip: "Verificação profunda de alterações de conteúdo nas imagens."
                },
                badges: {
                    contentChanged: "Imagem alterada",
                    contentChangedTooltip: "Detectamos que a imagem no site do cliente é diferente da que foi descrita/aprovada. O texto atual pode não corresponder mais ao que os usuários veem. Revise e atualize se necessário."
                },
                statuses: {
                    all: "Todos",
                    catalogued: "Sem descrição da IA",
                    "ai-generated": "Descrição da IA",
                    edited: "Editado",
                    approved: "Aprovado",
                    ignored: "Ignorada"
                },
                sources: {
                    all: "Todas as origens",
                    human: "Dev",
                    ai: "IA",
                    edited: "Curadoria"
                },
                cards: {
                    total: "Total de imagens",
                    totalSubtitle: "Em {{pages}} páginas",
                    withAlt: "Com texto alternativo (em uso)",
                    aiGeneratedField: "Geradas por IA",
                    humanReviewed: "Revisadas por humano",
                    pending: "Não revisadas (pendentes)",
                    percentOfTotal: "{{percent}}% do total",
                    // Legado — remover quando front antigo estiver desligado
                    missing: "Sem ALT",
                    aiGenerated: "Sugeridas pela IA",
                    needsReview: "Precisam revisão",
                    approved: "Aprovadas",
                    ignored: "Ignoradas"
                },
                table: {
                    url: "Página",
                    image: "Imagem",
                    fileName: "Arquivo",
                    altOriginal: "Texto alternativo original",
                    altCurrent: "Texto alternativo atual",
                    altInUse: "Texto alternativo em uso",
                    textSource: "Origem do texto",
                    review: "Atualização",
                    scoreIA: "Score IA",
                    pageUrl: "Página / URL",
                    detectedAt: "Detectado em",
                    status: "Status",
                    score: "Score",
                    actions: "Ações",
                    noResults: "Nenhuma imagem encontrada.",
                    resultsCount: "{{from}}-{{to}} de {{total}}",
                    rowsPerPage: "Linhas por página"
                },
                textSource: {
                    dev: "Dev",
                    ai: "IA",
                    aiEngine: "IA ({{engine}})",
                    manual: "Curadoria"
                },
                review: {
                    by: "Revisado por {{name}}",
                    approvedBy: "Aprovado por {{name}}",
                    savedBy: "Salvo por {{name}}",
                    editedBy: "Revisado por {{name}}",
                    ignoredBy: "Ignorado por {{name}}",
                    none: "Não revisado"
                },
                scoreLabel: {
                    excellent: "Excelente",
                    good: "Bom",
                    regular: "Regular",
                    weak: "Fraco",
                    na: "N/A"
                },
                actions: {
                    menu: "Mais ações",
                    edit: "Editar",
                    approve: "Aprovar",
                    regenerate: "Regenerar",
                    ignore: "Ignorar",
                    unignore: "Voltar a considerar"
                },
                sidePanel: {
                    details: "Detalhes",
                    currentAltLabel: "Alt atual",
                    empty: "—",
                    domain: "Domínio",
                    firstSeen: "Vista pela primeira vez em",
                    lastSeen: "Vista pela última vez em",
                    savedBy: "Salvo por",
                    approvedByLabel: "Aprovado por",
                    imageChangedBannerTitle: "Imagem alterada",
                    imageChangedBannerBody: "Esta imagem foi substituída no site após a descrição atual ter sido definida. O texto pode não descrever mais o que os usuários veem — revise e atualize se necessário.",
                    keepApprovedButton: "Manter aprovada",
                    keepApprovedHint: "ou use Editar / Regerar abaixo para alterar o texto",
                    pageViews: "Visualizações da página",
                    editButton: "Editar",
                    cancelEdit: "Cancelar",
                    saveEdit: "Salvar",
                    useAiSuggestion: "Usar esta sugestão",
                    regenerate: "Regenerar",
                    generateWithAi: "Gerar com IA",
                    regenerating: "Gerando novo alt com IA…",
                    regeneratingShort: "Regenerando…",
                    generating: "Gerando…",
                    approving: "Aprovando…",
                    regenerateSuccess: "Novo alt gerado pela IA",
                    regenerateTimeout: "A IA está demorando mais que o esperado. Tente novamente em instantes.",
                    regenerateConfirmTitle: "Regenerar com IA?",
                    regenerateConfirmBody: "Isso vai descartar o texto que você aprovou e gerar um novo com IA. Se o novo score ficar abaixo do limite, a imagem volta para 'Precisam revisão'. Continuar?",
                    regenerateConfirmAction: "Regenerar",
                    aiGeneratedAgo: "Gerado {{time}}",
                    charCount: "{{count}} caracteres",
                    approveButton: "Aprovar",
                    saveEditButton: "Aprovar",
                    savingEdit: "Aprovando…",
                    approveConfirmTitle: "Aprovar este texto?",
                    ignoreConfirmTitle: "Ignorar esta imagem?",
                    ignoreConfirmBody: "A imagem será marcada como decorativa. Leitores de tela vão pulá-la, sem anunciar nada. Você pode reverter a qualquer momento.",
                    ignoreConfirmConfirm: "Sim, ignorar",
                    ignoreConfirmCancel: "Cancelar",
                    ignoreButton: "Ignorar (decorativa)",
                    unignoreButton: "Voltar a considerar",
                    ignoredBadge: "Imagem ignorada — leitor de tela pula",
                    editedBy: "Editado por {{user}}",
                    editedAt: "em {{date}}",
                    approvedByAt: "Aprovado por {{user}} em {{date}}",
                    saveSuccess: "Alt salvo com sucesso",
                    approveSuccess: "Alt aprovado com sucesso",
                    ignoreSuccess: "Imagem marcada como decorativa",
                    unignoreSuccess: "Imagem voltou ao fluxo normal",
                    useSuggestionSuccess: "Sugestão da IA aplicada",
                    editPlaceholder: "Digite o texto alternativo desta imagem",
                    sourceBadge: {
                        ai: "Sugerido pela IA",
                        edited: "Editado manualmente",
                        approved: "Aprovado",
                        original: "Alt original",
                        none: "Sem descrição"
                    },
                    approval: {
                        emptyDevAlertBody: "A imagem não possui texto alternativo. É recomendado fornecer uma descrição.",
                        originalTitle: "Texto alternativo original",
                        originalNotProvided: "Não informado",
                        originalCodeLabel: "Detectado no código:",
                        aiSuggestedTitle: "Texto alternativo em uso",
                        aiSourceLabel: "Origem:",
                        aiSourceEngine: "IA ({{engine}})",
                        aiSourceGeneric: "IA",
                        curatorshipSource: "Curadoria",
                        devSource: "Dev",
                        approvedChip: "Aprovado",
                        reviewedChip: "Revisado",
                        aiSuggestionTitle: "Sugestão da IA",
                        aiSuggestionPlaceholder: "Sob demanda: gere uma sugestão da IA pra comparar com o texto atual.",
                        aiSuggestionLoading: "Gerando sugestão com IA…",
                        aiSuggestionError: "Não foi possível gerar a sugestão.",
                        aiSuggestionRetry: "Tentar de novo",
                        useSuggestion: "Usar esta sugestão",
                        generateSuggestion: "Gerar sugestão com IA",
                        saveChanges: "Salvar alterações",
                        cancel: "Cancelar",
                        aiSuggestedInfo: "Este texto foi gerado automaticamente pela IA. Revise e aprove se estiver adequado.",
                        pendingBadge: "Aguardando aprovação",
                        editButton: "Editar texto",
                        approveHint: "Após aprovar, este texto será utilizado no site.",
                        saveChangesButton: "Salvar alterações",
                        savingChanges: "Salvando…"
                    }
                }
            }
        },
        login:{
            title: "Olá!",
            subtitle: "Faça o login para gerenciar a sua jornada de acessibilidade digital.",
            email: "Seu email",
            password: "Sua senha",
            forgotPassword: "Esqueceu a senha?",
            remember: "Manter logado",
            newAccount:"iniciar um teste grátis",
            newPlatform:"Novo por aqui?",
            error: "Desculpe, mas algo deu errado. Por favor, verifique seu e-mail e sua senha e tente novamente.",
            loggedSuccessPartA: "Você se conectou com sucesso como um",
            loggedSuccessPartB: "Usuário para Assistive. Agora você pode começar a explorar. Aproveitar!",
            invalidLengthPass: "A senha deve ter no mínimo 8 caracteres.",
            invalidEmail :"Insira um email válido ex: \"email@mail.com\""
        },
        register : {
            title :"Comece agora seus 7 dias de teste grátis!",
            subtitle:"Não precisa cadastrar cartão de crédito",
            email: "Seu email",
            emailPlaceHold: "Email (obrigatório)",
            password: "Senha",
            name:"Qual o seu nome?",
            namePlaceHold: "Nome (obrigatório)",
            partnerPartA: "Quero ser um",
            partnerPartB: "da Assistive.",
            start: "Começar agora",
            agree: "Ao criar minha conta estou de acordo com os",
            haveAccount: "Já te uma conta?"
        },
        reset : {
            title :"Código de autenticação",
            subtitle:"Um email com o código de autenticação foi enviado para:",
            code: "Digite o código de 6 dígitos",
            valid: "Validar",
            codeSpan: "Não recebeu o código?"
        },
        forgot : {
            title :"Esqueceu a senha?",
            subtitle: "Informe seu email de cadastro e enviaremos instruções para você redefinir a sua senha.",
            sendInfo : "Enviar informações",
            backLogin: "Voltar ao login",
            sentTitle: "Instruções enviadas!",
            sentSubtitle: "Acabamos de enviar um email com as instruções para redefinir a sua senha"
        },
        installation: {
            viewCode: "Visualizar código de instalação",
            modalSendEmails: {
                title: 'Envie as instruções por e-mail',
                description: 'Para incluir mais de um endereço de e-mail, basta separá-los por vírgula.',
                emailLabel: 'E-mail',
                emailPlaceholder: 'endereço de e-mail.',
                invalidEmails: 'um ou mais emails são inválidos!',
                sendButton: 'Enviar instruções',
                successToast: 'Código encaminhado para os emails com sucesso'
            },
            wizard: {
                back: 'Voltar',
                next: 'Próximo',
                steps: {
                    method: 'Método',
                    personalize: 'Personalizar',
                    whitelabel: 'Marca',
                    generate: 'Gerar',
                },
                step1: {
                    title: 'Como deseja instalar o widget?',
                    subtitle: 'Escolha entre uma instalação rápida ou personalize visualmente antes de gerar o script.',
                    quickTitle: 'Instalação rápida',
                    quickDesc: 'Use o script padrão e instale o widget com poucos cliques.',
                    quickBtn: 'Usar script rápido',
                    quickFeature1: 'Rápido e simples',
                    quickFeature2: 'Ideal para configuração básica',
                    quickFeature3: 'Recomendado para planos simples',
                    configTitle: 'Instalação personalizada',
                    configDesc: 'Personalize visualmente o widget, gere um script único e compartilhe.',
                    configBtn: 'Personalizar widget',
                    configFeature1: 'Personalização visual completa',
                    configFeature2: 'Desktop, mobile e opções avançadas',
                    configFeature3: 'Gere JSON para reutilizar',
                    tip: 'Dica: você poderá alterar todas as configurações a qualquer momento.',
                },
                step2: {
                    title: 'Personalizar widget',
                    subtitle: 'Personalize a aparência, os botões e a posição do widget. As configurações são aplicadas separadamente para desktop e mobile.',
                    configuringFor: 'Configurando para:',
                    configTipPrefix: 'Todas as configurações nesta tela se aplicam ao',
                    preview: 'Prévia',
                    previewHintOpen: 'Clique no botão para abrir o widget',
                    previewHintClose: 'Clique no × para fechar',
                    tabs: {
                        appearance: 'Aparência',
                        buttons: 'Botões',
                        position: 'Posição',
                    },
                    appearanceDesc: 'Personalize o visual do botão (trigger) do widget.',
                    triggerLabel: 'Botão (trigger)',
                    btnShape: 'Formato do botão',
                    btnSize: 'Tamanho do botão',
                    btnIcon: 'Ícone do botão',
                    colorsLabel: 'Cores',
                    resetColors: 'Redefinir',
                    btnColor: 'Button color',
                    bodyColor: 'Window color',
                    colorSolid: 'Sólida',
                    colorOpacity: 'Opacidade',
                    shapes: {
                        circle: 'Círculo',
                        square: 'Quadrado',
                        rounded: 'Arredondado',
                    },
                    sizes: {
                        small: 'Pequeno',
                        medium: 'Médio',
                        large: 'Grande',
                    },
                    icons: {
                        default: 'Padrão',
                        config: 'Config',
                        gear: 'Engrenagem',
                        font: 'Fonte',
                    },
                    buttonsDesc: 'Ative ou desative os botões exibidos no widget.',
                    activeButtons: '{{active}} de {{total}} botões ativos',
                    buttons: {
                        textsize: { label: 'Texto maior', desc: 'Aumenta o tamanho do texto da página' },
                        font: { label: 'Alterar fonte', desc: 'Altera a fonte para melhorar a leitura' },
                        align: { label: 'Alinhamento do texto', desc: 'Ajusta o alinhamento do texto' },
                        linespacing: { label: 'Espaço entre linhas', desc: 'Ajusta o espaçamento entre linhas' },
                        charspacing: { label: 'Espaço entre letras', desc: 'Ajusta o espaçamento entre letras' },
                        image: { label: 'Sem imagens', desc: 'Remove imagens da página' },
                        semantic: { label: 'Dicionário Semântico', desc: 'Exibe definições semânticas das palavras' },
                        smartcontrast: { label: 'Contraste do texto', desc: 'Ajusta o contraste dos textos' },
                        contrast: { label: 'Contraste da página', desc: 'Ajusta o contraste de toda a página' },
                        saturation: { label: 'Intensidade das cores', desc: 'Ajusta a saturação das cores' },
                        colors: { label: 'Cores da página', desc: 'Ajusta as cores da página' },
                        readaloud: { label: 'Leitor de site', desc: 'Lê o conteúdo da página em voz alta' },
                        magnifying: { label: 'Lupa', desc: 'Amplia áreas da página' },
                        focus: { label: 'Destaque foco', desc: 'Destaca o elemento com foco no teclado' },
                        highlight: { label: 'Destacar elementos', desc: 'Destaca links, botões e títulos' },
                        cursor: { label: 'Cursor', desc: 'Aumenta o cursor do mouse' },
                        guide: { label: 'Guia de leitura', desc: 'Guia visual para acompanhar a leitura' },
                        ruler: { label: 'Régua de leitura', desc: 'Régua para acompanhar a leitura' },
                        tooltips: { label: 'Mostrar descrições', desc: 'Exibe descrições ao passar o mouse' },
                        animation: { label: 'Parar animações', desc: 'Remove animações da página' },
                        sound: { label: 'Sem som', desc: 'Desativa sons da página' },
                        struct: { label: 'Estrutura da página', desc: 'Exibe a estrutura de navegação' },
                        pdf: { label: 'Acessibilidade em PDF', desc: 'Adiciona acessibilidade a PDFs' },
                        vlibras: { label: 'VLibras', desc: 'Tradução para Língua Brasileira de Sinais', tooltip: 'Este recurso é disponibilizado pelo projeto VLibras do Governo Federal.' },
                    },
                    btnCategories: {
                        content: 'Conteúdo',
                        colors: 'Cor e tela',
                        navigation: 'Navegação',
                        libras: 'Libras',
                        features: 'Recursos adicionais',
                    },
                    libras: {
                        signsHumanActive: 'Ativar atendimento com intérprete humano',
                        signsHumanDesc: 'Recurso exclusivo do plano Enterprise.',
                        signsHumanUrl: 'URL do atendimento (videochamada)',
                        wlHumanSignsImgUri: 'URL da foto do intérprete',
                    },
                    widgetPreview: {
                        language: 'Português',
                        reset: 'Redefinir',
                        selectProfile: 'Selecionar perfis de uso',
                        improveExperience: 'Melhore sua experiência',
                        home: 'Início',
                        help: 'Ajuda',
                        openWidget: 'Abrir widget',
                        closeWidget: 'Fechar widget',
                        minimizeWidget: 'Minimizar widget',
                        widgetOpenedAnnounce: 'Widget de acessibilidade aberto. Pressione Tab para ir ao botão de fechar.',
                        widgetDialogLabel: 'Widget de acessibilidade Assistive',
                        libras: 'Libras',
                        librasHumanTitle: 'Atendimento em libras',
                        librasHumanSubtitle: 'Suporte em até 5 minutos.',
                        librasHumanDesc: 'Receba apoio de um intérprete de Libras durante sua navegação.',
                        librasRequest: 'Solicitar atendimento',
                        librasChoiceTitle: 'Recursos disponíveis',
                        librasChoiceSubtitle: 'Escolha o recurso que deseja utilizar.',
                        librasAutoTitle: 'Tradução automática',
                        librasAutoTag: 'Recurso externo',
                        librasAutoDesc: 'Traduz automaticamente o conteúdo da página para Libras com o avatar do VLibras.',
                        librasActivate: 'Ativar VLibras',
                    },
                    positionDesc: 'Escolha onde o botão do widget será exibido.',
                    horizontal: 'Horizontal',
                    left: 'Esquerda',
                    right: 'Direita',
                    vertical: 'Vertical',
                    top: 'Topo',
                    center: 'Centro',
                    bottom: 'Inferior',
                    offsets: 'Offsets (distância da borda selecionada)',
                    hOffset: 'Offset horizontal',
                    vOffset: 'Offset vertical',
                    offsetHint: 'Offset é a distância entre o botão e a borda da tela.',
                },
                step3wl: {
                    title: 'Marca',
                    subtitle: 'Personalize o widget com a sua marca. Exclusivo do plano Enterprise.',
                    previewingOn: 'Pré-visualizando em:',
                    configTip: 'Estas configurações se aplicam ao Desktop e ao Mobile.',
                    brandSection: 'Sua marca (white label)',
                    wlName: 'Nome da marca',
                    wlNamePlaceholder: 'Sua marca',
                    wlEmail: 'E-mail de contato',
                    wlLogoUri: 'URL do logo',
                    wlLogoLinkUri: 'Link do logo (site da marca)',
                    wlStatementUri: 'URL da declaração de acessibilidade',
                },
                step3: {
                    title: 'Gerar código de instalação',
                    subtitle: 'Copie o script e cole antes do fechamento da tag </body> no seu site.',
                    tabScript: 'Script inline',
                    tabJson: 'JSON de configuração',
                    copy: 'Copiar código',
                    copied: 'Copiado!',
                    sendEmail: 'Enviar por e-mail',
                },
            }
        },
        sites: {
            mySites: 'Meus sites',
            noSite: 'Você ainda não cadastrou nenhum site.',
            addNow:'Adicionar agora',
            plan: 'Plano',
            domain: 'Domínios',
            all: 'todos',
            inactive: 'inativos',
            actives: 'ativos',
            addSite: 'Adicionar Site',
            updatedSite: 'Atualizando site',
            code:'Visualizar código de instalação',
            search: 'Buscar',
            planStatus: {
                trial: {
                    daysRemaining: 'Faltam {{days}} dias para encerrar seu teste grátis',
                    hoursRemaining: 'Faltam {{hours}} horas para encerrar seu teste grátis',
                    expired: 'Seu período de testes encerrou, ative a licença para continuar usando'
                },
                active: {
                    renewal: 'Renovação automática em {{date}}.',
                    renewalDays: 'Renovação automática em {{days}} dias.'
                },
                expired: 'Seu plano expirou em {{date}}',
                grace: 'Seu plano está em período de carência e será desativado em {{date}}',
                cancelled: 'Seu plano está ativo até {{date}}'
            },
            actions: {
                activateLicense: 'Ativar licença',
                promotionalCode: 'Código promocional',
                updatePlan: 'Atualizar plano',
                completePlan: 'Concluir pagamento',
                cancelPlan: 'Cancelar plano',
                revertCancellation: 'Reverter cancelamento'
            },
            planDescription: {
                free: 'Para empresas com até 10 funcionarios, mediante a análise.',
                essential: 'Para empresesas com sites com baixo volume de acessos. Apenas 1(um) Domínio.',
                advanced: 'Plano até 10.000 page views. Para empresas volume de acesso intermediário e mais de um domínio. Até 2(dois) Domínios.',
                enterprise: 'Plano com page views ilimitadas. Para empresas com alto volume de acessos e que necessitam de serviços gerenciados e personalizados.'
            },
            trialLabel: 'TRIAL',
            modalCode: {
                description: 'Copie o código abaixo e implante em seu domínio',
                copyButton: 'Copiar Código',
                customInstallButton: 'Instalação personalizada'
            }
        },
        dashboard: {
            header: {
                title: 'Painel de acompanhamento'
            },
            periods: {
                lastMonth: 'Último mês',
                threeMonths: '3 meses',
                twelveMonths: '12 meses'
            },
            export: {
                button: 'Exportar',
                loading: 'Exportando...',
                error: 'Não foi possível exportar. Tente novamente.'
            },
            months: {
                jan: 'Jan',
                fev: 'Fev',
                mar: 'Mar',
                abr: 'Abr',
                mai: 'Mai',
                jun: 'Jun',
                jul: 'Jul',
                ago: 'Ago',
                set: 'Set',
                out: 'Out',
                nov: 'Nov',
                dez: 'Dez'
            },
            globalAlert: {
                title: 'Sem dados de uso ainda:',
                description: 'Estamos a coletar informações de uso para atualizar o painel.'
            },
            topMetrics: {
                pageViews: {
                    title: 'Page Views',
                    subtitle: 'Total de visualizações de páginas'
                },
                pluginOpens: {
                    title: 'Aberturas do Plugin',
                    subtitle: 'Total de vezes que o plugin foi aberto'
                },
                totalEvents: {
                    title: 'Total de Eventos',
                    subtitle: 'Interações totais com o plugin'
                },
                emptyDash: '--'
            },
            usageOverTime: {
                title: 'Uso ao longo do tempo',
                seriesName: 'Eventos',
                error: {
                    message: 'Não foi possível carregar os dados.',
                    retry: 'Tentar Novamente'
                },
                empty: {
                    title: 'Comece a usar seu plugin para ver o desempenho',
                    subtitle: 'Aqui, você vai entender a utilização do plugin ao longo dos meses.'
                },
                noDomain: {
                    title: 'Cadastre um domínio e comece a usar para ver o desempenho',
                    subtitle: 'Aqui você vai entender a utilização do plugin ao longo do tempo'
                }
            },
            insights: {
                title: 'Tendências e Insights',
                error: {
                    message: 'Não foi possível carregar os dados.',
                    retry: 'Tentar Novamente'
                },
                empty: {
                    title: 'Aguarde a coleta de dados',
                    subtitle: 'Estamos a coletar informações para exibir as tendências e Insights.'
                },
                noDomain: {
                    title: 'Cadastre um domínio e comece a usar para ver o desempenho',
                    subtitle: 'Aqui você vai ver as tendências e insights sobre a utilização do plugin'
                },
                dynamic: {
                    topFeature: {
                        prefix: 'A ferramenta ',
                        middle: ' foi a mais utilizada, acumulando ',
                        suffix: ' eventos no período.'
                    },
                    peakUsage: {
                        dayPrefix: 'O dia ',
                        monthPrefix: 'O mês de ',
                        middle: ' registrou o maior volume de uso, alcançando ',
                        suffix: ' eventos.'
                    },
                    topProfile: {
                        prefix: 'O perfil de navegação ',
                        middle: ' liderou em número de ativações, sendo acionado ',
                        suffix: ' vezes.'
                    }
                }
            },
            resourcesRanking: {
                title: 'Recursos mais utilizados',
                error: {
                    message: 'Falha ao carregar informações',
                    retry: 'Tentar Novamente'
                },
                empty: {
                    title: 'Sem dados de uso ainda',
                    subtitle: 'Estamos a coletar informações para exibir estas informações.'
                },
                noDomain: {
                    title: 'Cadastre um domínio e comece a usar para ver o desempenho',
                    subtitle: 'Aqui você vai ver quais recursos do plugin são mais utilizados pelos seus usuários'
                },
                footer: 'Resultado mensal de todos os recursos utilizados.',
                events: 'eventos'
            },
            profiles: {
                title: 'Distribuição de Perfis utilizados',
                error: {
                    message: 'Não foi possível carregar os dados.',
                    retry: 'Tentar Novamente'
                },
                empty: {
                    title: 'Sem dados de uso ainda',
                    subtitle: 'Estamos a coletar informações para exibir estas informações.'
                },
                noDomain: {
                    title: 'Cadastre um domínio e comece a usar para ver o desempenho',
                    subtitle: 'Aqui você vai ver como os perfis de acessibilidade estão sendo utilizados'
                },
                footerLinkText: 'Entenda como funciona os perfis de acessibilidade',
                iconAlt: 'Ícone',
                arrowAlt: 'Seta',
                tooltip: {
                    eventsLabel: 'eventos'
                }
            },
            detailedUsage: {
                title: 'Uso detalhado dos recursos',
                filter: {
                    all: 'Todos',
                    categories: {
                        content: 'Conteúdo',
                        navigation: 'Navegação',
                        colorAndScreen: 'Cor e Tela'
                    }
                },
                searchPlaceholder: 'Buscar',
                searchAlt: 'Pesquisar',
                subtitleAll: 'Todos',
                subtitleFiltered: 'Resultados Filtrados',
                error: {
                    message: 'Não foi possível carregar os dados.',
                    retry: 'Tentar Novamente'
                },
                empty: {
                    noData: 'Sem dados de uso disponíveis no momento.',
                    noResults: 'Nenhum recurso encontrado para esta busca.'
                },
                events: 'eventos'
            }
        },
        accountSettings: {
            title: 'Configurações da conta',
            tabs: {
                account: 'Conta',
                security: 'Segurança',
                billing: 'Cobrança & Plano',
                payment: 'Pagamento'
            },
            accountTab: {
                sectionTitle: 'Tipo de conta',
                saveButton: 'Salvar alterações',
                cancelButton: 'Cancelar'
            },
            deleteAccount: {
                title: 'Excluir conta',
                warningStrong: 'Você tem certeza que deseja excluir essa conta?',
                // warningText: removido — self-service de exclusão foi substituído por solicitação ao suporte
                // warningText: 'Depois de excluir sua conta, não há como voltar atrás. Por favor, tenha certeza.',
                consequencesTitle: 'Esta ação não pode ser desfeita. Ao excluir sua conta:',
                consequence1: 'O widget de acessibilidade para de funcionar imediatamente em todos os seus sites.',
                consequence2: 'Sua assinatura é cancelada e nenhuma nova cobrança será realizada.',
                consequence3: 'Domínios, configurações e histórico de faturas são removidos permanentemente.',
                // confirmLabel/button antigos: removidos junto com o checkbox de auto-confirmação
                // confirmLabel: 'Confirmar exclusão da minha conta',
                // button: 'Excluir conta',
                requestButton: 'Solicitar exclusão',
                modal: {
                    title: 'Solicitar exclusão de conta',
                    body: 'A exclusão é feita pelo suporte para garantir segurança e conformidade.',
                    previewTitle: 'Dados que serão enviados ao suporte:',
                    fieldAccount: 'Conta',
                    fieldCompany: 'Empresa',
                    fieldDocument: 'Documento',
                    fieldOwner: 'Responsável',
                    fieldEmail: 'E-mail',
                    fieldPhone: 'Telefone',
                    fieldPlan: 'Plano',
                    send: 'Enviar solicitação',
                    sending: 'Enviando...',
                    cancel: 'Cancelar',
                    successToast: 'Solicitação enviada. Entraremos em contato em até 3 dias úteis.',
                    errorToast: 'Não foi possível enviar. Tente novamente em instantes.',
                    // Legado (mailto): o botão foi trocado por chamada ao backend
                    // emailSupport: 'Enviar e-mail para suporte',
                    // body1/body2/confirm antigos: removidos — modal agora encaminha pro suporte
                    // body1: 'Esta ação é irreversível. Todos os seus dados, domínios e configurações serão permanentemente excluídos.',
                    // body2: 'Se você possui um plano ativo, ele será cancelado imediatamente.',
                    // confirm: 'Sim, excluir minha conta',
                }
            },
            formBilling: {
                taxpayerTypeCorporate: 'Pessoa Jurídica',
                taxpayerTypePersonal: 'Pessoa Física',
                companyDataTitle: 'Dados da empresa',
                personalDataTitle: 'Dados pessoais',
                cpfLabel: 'Documento de identificação (CPF)',
                cpfInvalid: 'CPF inválido',
                cnpjLabel: 'Documento de identificação (CNPJ)',
                cnpjInvalid: 'CNPJ inválido',
                simplesLabel: 'Optante pelo Simples Nacional?',
                simplesYes: 'Sim',
                simplesNo: 'Não',
                corporateName: 'Razão social',
                fullName: 'Nome completo',
                fantasyName: 'Nome fantasia',
                required: 'Campo obrigatório',
                financialContact: 'Contato Financeiro',
                responsibleName: 'Nome do responsável',
                responsibleNamePlaceholder: 'Nome responsável',
                financialEmail: 'Email (que receberá a fatura)',
                emailInvalid: 'Email informado é inválido',
                phone: 'Telefone',
                phoneInvalid: 'Telefone informado é inválido!',
                address: 'Endereço',
                zipCode: 'CEP',
                zipCodeInvalid: 'CEP inválido',
                number: 'Número',
                complement: 'Complemento',
                neighborhood: 'Bairro',
                state: 'Estado',
                city: 'Cidade',
                toast: {
                    loading: 'Salvando requisição',
                    success: 'Salvo.',
                    error: 'Erro ao salvar requisição, tente novamente mais tarde'
                }
            },
            limitePlan: {
                title: 'Limites do plano',
                availableDomains: 'Domínios disponíveis',
                pageviewsPerMonth: 'Pageviews por mês'
            },
            securityTab: {
                title: 'Senha',
                subtitle: 'Sua senha é gerenciada pelo sistema de autenticação. Para alterá-la, você será redirecionado para uma página segura.',
                passwordLabel: 'Senha',
                changePasswordButton: 'Alterar senha'
            },
            paymentTab: {
                title: 'Forma de pagamento',
                subtitle: 'Gerencie o cartão vinculado à sua assinatura.',
                cardLabel: 'Cartão',
                noCard: 'Nenhum cartão cadastrado',
                nextBilling: 'Próxima cobrança',
                changeCard: 'Alterar cartão',
                addCard: 'Adicionar cartão',
                changeCardNotice: 'Ao clicar no botão acima, você será redirecionado para uma página de pagamento segura. Uma cobrança de R$5,00 será realizada para validar o cartão e, em seguida, estornada automaticamente.',
                errorChangeCard: 'Erro ao solicitar troca de cartão. Tente novamente.',
                removeCard: 'Remover cartão',
                successRemoveCard: 'Cartão removido com sucesso.',
                errorRemoveCard: 'Erro ao remover cartão. Tente novamente.',
                removeModal: {
                    title: 'Remover cartão',
                    body: 'Tem certeza que deseja remover o cartão cadastrado? Cobranças automáticas deixarão de funcionar até que um novo cartão seja informado.',
                    confirm: 'Remover',
                    cancel: 'Cancelar'
                },
                modal: {
                    title: 'Alterar forma de pagamento',
                    titleAdd: 'Cadastrar forma de pagamento',
                    body1: 'Seu cartão atual será removido e você continuará o cadastro do novo cartão na página do Asaas, em uma nova aba.',
                    body1Add: 'Você continuará o cadastro do seu cartão na página do Asaas, em uma nova aba.',
                    body2: 'Cobrança de validação: <b>R$ 5,00</b>, estornada automaticamente.',
                    body3: 'Você ficará sem cartão cadastrado até concluir o processo. Se não concluir, seu plano poderá ser cancelado na próxima renovação.',
                    body4: 'O estorno pode levar de <b>1 a 15 dias</b> para aparecer na sua fatura.',
                    confirm: 'Continuar para o pagamento',
                    cancel: 'Cancelar',
                    close: 'Fechar',
                    waitingTitle: 'Aguardando confirmação',
                    waitingBody: 'Conclua o cadastro do novo cartão na página que abrimos em outra aba. Esta janela será atualizada automaticamente assim que o cartão for confirmado.',
                    reopen: 'Reabrir página de pagamento',
                    successTitle: 'Cartão atualizado!',
                    successBody: 'Seu novo cartão foi cadastrado com sucesso.',
                    timeoutTitle: 'Processo pendente',
                    timeoutBody: 'Ainda não recebemos a confirmação do novo cartão. Se você concluiu o cadastro, os dados serão atualizados em breve.'
                }
            },
            invoiceTable: {
                title: 'Histórico de faturas',
                headers: {
                    date: 'Data',
                    invoiceNumber: 'Número de cobrança',
                    plan: 'Plano',
                    amount: 'Valor',
                    status: 'Status'
                },
                statuses: {
                    PENDING: 'Pendente',
                    PAID: 'Paga',
                    PARTIALLY_PAID: 'Parcialmente paga',
                    OVERDUE: 'Vencida',
                    CANCELED: 'Cancelada',
                    REFUNDED: 'Estornada'
                },
                filterAll: 'Todos os status',
                actions: {
                    download: 'Download da fatura',
                    view: 'Visualizar fatura'
                },
                empty: 'Você não possui nenhuma cobrança.'
            }
        },
        firstFlow: {
            title: 'Olá {{name}}, queremos te dar as boas vindas à Assistive! 🤩',
            subtitle: 'Vamos começar a sua jornada por um mundo digital mais acessível? Informe o site da sua empresa para receber o seu código de instalação.',
            siteLabel: 'Site',
            siteTooltip: 'Você poderá adicionar outros sites depois.',
            sitePlaceholder: 'Seu site (obrigatório)',
            siteInvalid: 'Endereço informado inválido! Utilize o formato semelhante aos exemplos: https://assistive.com.br e http://assistive.com.br.',
            accountNameLabel: 'Nome da conta',
            accountNameTooltip: 'Nome para identificar sua conta na Assistive. Pode ser o nome da sua empresa ou o seu nome, por exemplo.',
            accountNamePlaceholder: 'Sua conta',
            couponLabel: 'Código promocional',
            couponInsert: 'Inserir',
            couponQuestion: 'Tem um código promocional?',
            startTrial: 'Iniciar teste grátis por {{days}} dias',
            subscribePlan: 'Assinar plano mensal a partir de {{price}}',
            toastSuccess: 'Dados atualizados.',
            toastError: 'Erro ao atualizar conta',
            siteRequired: 'Informe um site válido'
        },
        plans: {
            header: {
                title: 'Planos'
            },
            choose: {
                title: 'Escolha o plano mais adequado para o seu negócio.',
                incompleteBanner: {
                    title: 'Você tem um pagamento pendente',
                    description: 'Sua assinatura do plano {{planName}} foi criada mas o pagamento ainda não foi concluído.',
                    completePayment: 'Concluir pagamento',
                    chooseAnother: 'Escolher outro plano'
                },
                graceBanner: {
                    title: 'Pagamento pendente',
                    description: 'Seu plano {{planName}} possui uma fatura em aberto. Confirme o pagamento para continuar com acesso completo.',
                    confirmPayment: 'Confirmar pagamento',
                    pendingPayment: 'Pagamento pendente'
                },
                cancelledBanner: {
                    revertCancellation: 'Reverter cancelamento'
                },
                pendingDowngrade: 'Você já possui um downgrade agendado para este plano. A mudança entrará em vigor na próxima renovação.',
                pendingDowngradeBanner: {
                    title: 'Downgrade agendado',
                    description: 'Seu plano será rebaixado para {{planName}} na próxima renovação. Cancele caso queira permanecer no plano atual.',
                    cancelBtn: 'Cancelar downgrade',
                    cancelSuccess: 'Downgrade cancelado. Seu plano permanece o mesmo.',
                    cancelError: 'Erro ao cancelar downgrade. Tente novamente.',
                    scheduledBtn: 'Downgrade agendado'
                }
            },
            form: {
                backToPlans: 'escolher plano',
                registration: {
                    title: 'Cadastro',
                    subtitle: 'Selecione o tipo de cadastro que você deseja e preencha os campos para continuar. Todos os campos são obrigatórios'
                },
                resume: {
                    title: 'Resumo',
                    plan: 'Plano',
                    billing: 'Cobrança',
                    monthly: 'Mensal',
                    totalValue: 'Valor total',
                    free: 'Grátis',
                    enterprise: 'Sob Consulta',
                    perMonth: '/mês',
                    finalize: 'Finalizar cadastro'
                },
                upgradeNotice: 'Como você já tem um plano ativo, será cobrado o valor proporcional aos dias restantes do ciclo atual.',
                downgradeNotice: 'Você continuará com acesso ao plano atual até o fim do período de cobrança. O novo plano entrará em vigor na próxima renovação.',
                loading: {
                    saving: 'Salvando dados...',
                    generating: 'Gerando link de pagamento...',
                    processing: 'Processando mudança de plano...'
                },
                error: {
                    checkoutIntegration: 'Não foi possível processar seu pagamento. O CPF/CNPJ informado é inválido. Clique no botão abaixo para corrigir seus dados de cadastro.',
                    generateLink: 'Não foi possível gerar o link de pagamento. Tente novamente mais tarde.',
                    saveBilling: 'Erro ao salvar dados de cobrança',
                    correctData: 'Corrigir dados de cadastro',
                    tryAgain: 'Tentar novamente'
                },
                changePlan: {
                    alreadyRequested: 'Você já solicitou uma troca de plano hoje. A mudança será aplicada no fim do ciclo.',
                    pendingInvoice: 'Existe um pagamento pendente. Conclua o pagamento antes de trocar o plano.',
                    alreadySelected: 'Seu plano já é o selecionado.',
                    notFound: 'Plano não encontrado. Tente novamente ou entre em contato com o suporte.',
                    invalidState: 'Não é possível trocar o plano no estado atual da sua assinatura.',
                    genericError: 'Erro ao trocar plano'
                },
                confirmTrial: {
                    notFound: 'Subscrição ou plano não encontrado. Tente novamente ou entre em contato com o suporte.',
                    alreadyConfirmed: 'Sua subscrição já foi confirmada.',
                    genericError: 'Erro ao confirmar trial'
                },
                renewSubscription: {
                    notFound: 'Subscrição não encontrada. Tente novamente ou entre em contato com o suporte.',
                    alreadyActive: 'Sua subscrição já está ativa.',
                    genericError: 'Erro ao reativar subscrição'
                }
            },
            changeConfirm: {
                titleUpgrade: 'Confirmar upgrade',
                titleDowngrade: 'Confirmar downgrade',
                subtitleUpgrade: 'Revise os detalhes abaixo e confirme a mudança para o plano superior.',
                subtitleDowngrade: 'Revise os detalhes abaixo e confirme a mudança para o plano inferior.',
                summary: 'Resumo da mudança',
                currentPlan: 'Plano atual',
                newPlan: 'Novo plano',
                paymentMethod: 'Forma de pagamento',
                confirmUpgrade: 'Confirmar upgrade',
                confirmDowngrade: 'Confirmar downgrade',
                back: 'Voltar'
            },
            upgradeCompleted: {
                title: 'Upgrade concluído!',
                subtitle: 'Seu plano foi atualizado com sucesso.',
                infoTitle: 'O que acontece agora?',
                info1: 'O novo plano já está ativo na sua conta.',
                info2: 'O valor proporcional ao período restante foi cobrado automaticamente no seu cartão.',
                summary: 'Resumo da mudança',
                previousPlan: 'Plano anterior',
                newPlan: 'Novo plano',
                goToDashboard: 'Ir para o dashboard',
            },
            downgradeScheduled: {
                title: 'Downgrade agendado',
                subtitle: 'Seu plano atual permanece ativo até o fim do ciclo.',
                infoTitle: 'O que acontece agora?',
                info1: 'Seu plano atual continua ativo normalmente até a data de renovação.',
                info2: 'Na próxima renovação, o novo plano entrará em vigor automaticamente.',
                summary: 'Resumo da mudança',
                currentPlan: 'Plano atual',
                newPlan: 'Novo plano',
                validUntil: 'Plano atual válido até',
                goToDashboard: 'Ir para o dashboard',
            },
            paymentReady: {
                title: 'Pagamento pendente',
                subtitle: 'Seu cadastro foi concluído. Finalize o pagamento para ativar sua conta.',
                securePayment: 'Pagamento seguro com a Asaas',
                securePaymentDesc: 'Para garantir a segurança dos seus dados financeiros, o pagamento será processado pela Asaas, instituição financeira especializada em cobranças online.',
                whatHappensNow: 'O que acontece agora?',
                step1Title: 'Você será redirecionado',
                step1Desc: 'Você será direcionado para a página segura da Asaas em uma nova aba.',
                step2Title: 'Finalize o pagamento',
                step2Desc: 'Escolha a forma de pagamento e conclua sua compra com total segurança.',
                step3Title: 'Confirmação automática',
                step3Desc: 'Após a confirmação do pagamento, sua conta será ativada automaticamente.',
                secureEnv: 'Ambiente 100% seguro',
                secureEnvDesc: 'A Asaas utiliza criptografia SSL de 256 bits e segue os mais altos padrões de segurança do mercado.',
                summary: 'Resumo da sua contratação',
                plan: 'Plano',
                value: 'Valor',
                perMonth: '/mês',
                recurringInfo: '✓ Cobrança recorrente mensal • Cancele quando quiser',
                linkGeneratedOn: 'Link de pagamento gerado em',
                validUntil: 'Válido até',
                validFor: '(72h)',
                goToPayment: 'Ir para o pagamento seguro',
                redirectNotice: 'Você será redirecionado para o site da Asaas em uma nova aba.',
                returnNotice: 'Após o pagamento, você pode fechar a aba e retornar à Assistive.',
                emailSent: 'Enviamos o link de pagamento para',
                emailNotReceived: 'Não recebeu? Verifique sua caixa de spam.'
            }
        },
        billing: {
            success: {
                checkingStatus: 'Verificando pagamento...',
                checkingHint: 'Em até 5 minutos sua conta será ativada.',
                checkingError: 'Não conseguimos confirmar o pagamento.',
                checkingErrorHint: 'Seu pagamento pode ter sido processado mesmo assim. Verifique seu e-mail ou tente novamente.',
                tryAgain: 'Tentar novamente',
                title: 'Pagamento confirmado!',
                subtitle: 'Sua assinatura foi ativada com sucesso. Seja bem-vindo à Assistive!',
                planActive: 'Seu plano {{planName}} está ativo',
                planActiveDesc: 'Aproveite todos os recursos da Assistive.',
                goToDashboard: 'Acessar dashboard',
                summaryTitle: 'Resumo da confirmação',
                paymentStatus: 'Status do pagamento',
                approved: 'Aprovado',
                dateTime: 'Data',
                plan: 'Plano',
                billing: 'Cobrança',
                monthly: 'Mensal',
                nextBilling: 'Próxima cobrança',
                amountPaid: 'Valor pago',
                whatNow: 'O que acontece agora?',
                accessUnlocked: 'Acesso liberado',
                accessUnlockedDesc: 'Todos os recursos do seu plano já estão disponíveis.',
                autoRenewal: 'Cobrança automática',
                autoRenewalDesc: 'Você será cobrado automaticamente todo mês.',
                invoice: 'Notas fiscais',
                invoiceDesc: 'Você receberá a nota fiscal automaticamente por e-mail.',
                orderSummary: 'Resumo do pedido',
                paidOn: 'Pago em',
                paymentApproved: 'Pagamento aprovado'
            },
            cancel: {
                title: 'Pagamento cancelado',
                subtitle: 'Você cancelou o processo de pagamento.',
                whatNow: 'O que fazer agora?',
                whatNowDesc: 'Você pode voltar à página de planos e tentar novamente a qualquer momento.',
                tryAgain: 'Tentar novamente',
                orderSummary: 'Resumo do pedido',
                plan: 'Plano',
                billing: 'Cobrança',
                monthly: 'Mensal',
                paymentCancelled: 'Pagamento cancelado'
            },
            expired: {
                title: 'Link de pagamento expirado',
                subtitle: 'O link de pagamento gerou expirou. Gere um novo para continuar.',
                whatNow: 'O que fazer agora?',
                whatNowDesc: 'Gere um novo link de pagamento para continuar com a contratação do seu plano.',
                generateNewLink: 'Gerar novo link',
                orderSummary: 'Resumo do pedido',
                plan: 'Plano',
                billing: 'Cobrança',
                monthly: 'Mensal',
                linkExpired: 'Link expirado'
            }
        },
        perfil: {
            title: 'Perfil',
            userInfo: {
                title: 'Informações do usuário',
                subtitle: 'Atualize as informações do seu usuário',
                fullName: 'Nome completo',
                nickname: 'Apelido',
                email: 'Endereço de e-mail',
                phone: 'Telefone',
                required: 'Esse é um campo obrigatório',
                saveButton: 'Salvar alterações',
                changePasswordButton: 'Alterar senha',
                toast: {
                    loading: 'Atualizando informação',
                    success: 'Informações Atualizadas',
                    error: 'Erro ao Atualizar informações'
                }
            },
            changePassword: {
                title: 'Alterar senha',
                subtitle: 'A senha deve conter pelo menos 8 caracteres.',
                oldPassword: 'Senha antiga',
                newPassword: 'Nova senha',
                required: 'Esse é um campo obrigatório',
                minLength: 'A senha deve ter no mínimo 8 caracteres.',
                button: 'Alterar senha',
                toast: {
                    error: 'Senha incorreta',
                    success: 'Alterada com sucesso'
                }
            }
        },
        features: {
            tags: {
                conteudo: 'Conteúdo',
                navegacao: 'Navegação',
                corTela: 'Cor e Tela',
                perfil: 'Perfil'
            },
            init: 'Page views',
            toolbarT: 'Abertura de Plugin',
            textsize1T: 'Texto Maior 125%',
            textsize2T: 'Texto Maior 140%',
            textsize3T: 'Texto Maior 170%',
            textsize4T: 'Texto Maior 200%',
            align_centerT: 'Alinhamento Centralizado',
            align_justifyT: 'Alinhamento Justificado',
            align_leftT: 'Alinhamento à Esquerda',
            align_rightT: 'Alinhamento à Direita',
            font_dyslexicT: 'Fonte para Dislexia',
            font_sansserifT: 'Fonte sem Serifa (Leitura)',
            font_serifT: 'Fonte com Serifa',
            linespacing1T: 'Espaçamento de Linhas 120%',
            linespacing2T: 'Espaçamento de Linhas 140%',
            linespacing3T: 'Espaçamento de Linhas 160%',
            charspacing1T: 'Espaçamento de letras 105%',
            charspacing2T: 'Espaçamento de letras 110%',
            charspacing3T: 'Espaçamento de letras 120%',
            imageT: 'Sem imagens',
            spkOpen: 'Leitor de Site',
            tooltipsT: 'Mostrar Descrições',
            imgdescT: 'Descrições de Imagens',
            soundT: 'Sem Som',
            vlibrasT: 'Libras',
            semanticT: 'Dicionário Semântico',
            smartcontrast_defaultT: 'Contraste de Texto Mínimo',
            smartcontrast_highT: 'Contraste de Texto Médio',
            smartcontrast_maxT: 'Contraste de Texto Máximo',
            contrast1T: 'Contraste da Página 125%',
            contrast2T: 'Contraste da Página 150%',
            contrast3T: 'Contraste da Página 175%',
            contrast4T: 'Contraste da Página 200%',
            contrast5T: 'Contraste da Página 300%',
            saturation_dessaturateT: 'Cores Desbotadas',
            saturation_highT: 'Cores Intensas',
            saturation_lowT: 'Tons de Cinza',
            colors_invertT: 'Inverter Cores',
            colors_shift60T: 'Cores (Rotaciona 60°)',
            colors_shift120T: 'Cores (Rotaciona 120°)',
            colors_shift240T: 'Cores (Rotaciona 240°)',
            magnifyingT: 'Lupa',
            structclick: 'Estrutura da Pagina',
            cursor_blackT: 'Cursor Preto',
            cursor_blueT: 'Cursor Azul',
            cursor_redT: 'Cursor Vermelho',
            cursor_whiteT: 'Cursor Branco',
            guideT: 'Guia de Leitura',
            rulerT: 'Regua de Leitura',
            animationT: 'Para Animações',
            highlight_allT: 'Destacar Todos Elementos',
            highlight_btnT: 'Destacar Botões',
            highlight_linkT: 'Destacar Links',
            highlight_titleT: 'Destacar Títulos',
            focusT: 'Destaque Foco do Teclado',
            prof_p60_T: 'Navegação 60+',
            prof_seizures_T: 'Navegação Epilepsia',
            prof_vision_T: 'Navegação Baixa Visão',
            prof_adhd_T: 'Navegação TDAH',
            prof_dyslexic_T: 'Navegação Dislexia',
            prof_cognitive_T: 'Navegação auxílio cognitivo',
            prof_motor_T: 'Navegação por teclado',
            prof_blind_T: 'Navegação por leitores de tela (Cego)'
        }
    }
}
